export default __webpack_public_path__ + "static/map-shape1-8796880d489697cd5ec846f111bddc5e.png";